import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { useState } from "react";

const DetailItem = ({
  label,
  value,
  valueColor,
  valueWeight,
  copyable = false,
  icon = null,
  multiline = false,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block">
        {label}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {icon && (
          <Box sx={{ display: "flex", color: valueColor || "text.primary" }}>
            {icon}
          </Box>
        )}
        <Typography
          variant="body1"
          fontWeight={valueWeight || "medium"}
          color={valueColor || "text.primary"}
          sx={{
            flexGrow: 1,
            wordBreak: multiline ? "break-word" : "normal",
          }}
        >
          {value || "N/A"}
        </Typography>
        {copyable && value && (
          <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
            <IconButton
              size="small"
              onClick={handleCopy}
              sx={{
                opacity: 0.7,
                "&:hover": { opacity: 1 },
                transition: "opacity 0.2s",
              }}
            >
              {copied ? (
                <CheckIcon fontSize="small" color="success" />
              ) : (
                <ContentCopyIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

export default DetailItem;
